angular.module('moebiusProadapt').controller('ctrlAdminAddCentre',
    [
        '$scope', '$http', '$location', '$uibModal', 'promiseTracker', 'centre', 'growl', function($scope, $http, $location, $uibModal, promiseTracker, centre, growl) {

        $scope.tracker = promiseTracker('tracker');
        $scope.centre = centre;

        //at form validation, send its data to back to create a new user
        $scope.editCentre = function(centre) {
            centre.editOrSave = centre.id ? 'EDIT' : 'SAVE' ;

            return $http.post('centre', centre)
                        .then(function(r) {
                            $scope.$close(r.data);
                            if(centre.editOrSave === "SAVE") {
                                growl.warning("Centre créé côté ProAdapt : avant toute entrée d'utilisateur ou de participant pour ce nouveau centre, veuillez contacter Anamnèse en leur indiquant le nom et l'id de ce nouveau centre afin qu'ils l'enregistrent aussi de leur côté. <br/>Nom : "+ r.data.name +" <br/>Id : " + r.data.id ) ;
                            } else {
                                growl.warning("Centre modifié côté ProAdapt : avant toute nouvellle entrée d'utilisateur ou de participant pour ce centre, veuillez contacter Anamnèse en leur indiquant le nouveau nom de ce centre et son id afin qu'ils le modifient aussi de leur côté. <br/>Nouveau nom : "+ r.data.name +" <br/>Id de centre existant : " + r.data.id ) ;
                            }
                        });
        };

        //at form validation, send its data to back to create a new user
        $scope.desactivateCentre = function(centre) {

            return $http.delete('centre', centre)
                        .then(function(r) {
                            if(r.data.deleted_at !== null) {
                                let indexC = _.findIndex($scope.centres, { id: r.data.centre_id });
                                $scope.centres.splice(indexC, 1);
                            }
                            $scope.$close(r.data);
                        });
        }

    }
    ]
);


// WEBPACK FOOTER //
// ./resources/assets/js/controllers/admin/adminAddCentre.js